export default "__VITE_ASSET__BdPIAPmm__"